import { Component, OnDestroy, OnInit } from '@angular/core';
import { DoggyhubService } from '../doggyhub/doggyhub.service';
import { ActivatedRoute, Router } from '@angular/router';
import { GetArticleResponseDTO } from '../doggyhub/doggyhub.dto';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Share } from '@capacitor/share';
import { formatDate } from '@angular/common';
import { Clipboard } from '@capacitor/clipboard';
import { ToastController } from '@ionic/angular';
@Component({
  selector: 'app-article',
  templateUrl: './article.page.html',
  styleUrls: ['./article.page.scss'],
})
export class ArticlePage implements OnInit, OnDestroy {
  isLoading = true;
  article: GetArticleResponseDTO;
  articleSub: Subscription;
  articleDate: string;
  url: string;
  constructor(
    private doggyhubService: DoggyhubService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private toastController: ToastController
  ) {}

  ngOnInit() {
    const articleId = +this.activatedRoute.snapshot.params.id;
    this.articleSub = this.doggyhubService
      .getArticleById(articleId)
      .subscribe((res) => {
        this.article = res;
        this.url = environment.appUrl + this.router.url;
        this.articleDate = this.formatDateTime(this.article.dateAdded);
        this.isLoading = false;
      });
  }

  formatDateTime(myDate: Date) {
    const format = 'dd-MMM-yyyy h:mm a';
    const locale = 'en-US';
    const formattedDate = formatDate(myDate, format, locale).split(' ');
    return (
      formattedDate[0] + ' at ' + formattedDate[1] + ' ' + formattedDate[2]
    );
  }

  ngOnDestroy() {
    if (this.articleSub) this.articleSub.unsubscribe();
  }
  async shareArticle() {
    await Share.share({
      title: 'Check this out',
      text: `Check out this article!! ${this.url}`, // Combine text and URL
    });
  }

  async copyLink() {
    try {
      await Clipboard.write({
        string: this.url,
      });

      const toast = await this.toastController.create({
        message: 'URL copied to clipboard!',
        color: 'primary',
        duration: 2000,
        position: 'bottom',
      });
      toast.present();
    } catch (error) {
      console.error('Failed to copy URL:', error);
      const toast = await this.toastController.create({
        message: 'Failed to copy URL.',
        duration: 2000,
        position: 'bottom',
      });
      toast.present();
    }
  }
}
